<template>
	<div :class="$style.box">
		<template>
			<div class="inner-box">
				<el-button v-for="(item, index) in productItems" :key="index" class="is-round is-fullwidth"
					style="text-align: left;">
					<span class="flex-btn">
						<span class="btn-text">{{ item.name }}</span>
						<div style="cursor: pointer; padding: 10px; margin: -10px">
							<BaseIcon name="times"></BaseIcon>
						</div>
					</span>
				</el-button>
				<span v-if="!productItems.length">{{ emptyName }}</span>
			</div>
			<el-button class="is-round is-fullwidth" @click="creatAvaliableProdects">
				<BaseIcon name="plus" /> {{ buttonName }}
			</el-button>
		</template>

		<!-- 新增適用適用分店，跳窗 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="80%" top="0" append-to-body>
			<el-input :placeholder="dialogPlaceHolder" class="is-border smsInput" style="margin-bottom: 15px;"
				v-model="dialogFilter">
				<BaseIcon slot="prefix" name="search" class="el-input__icon" />
			</el-input>
			<el-form label-position="top" class="isWrap">
				<el-form-item style="min-height: 250px" :class="$style['services-wrap']">
					<div :class="$style.dialogTitle">
						<el-checkbox v-model="checkAllBtn" @change="checkBoxAllSelectProduct"
							style="margin-left: 5px; margin-top: 10px; margin-bottom: 5px">全 選
						</el-checkbox>
					</div>
					<el-checkbox-group v-model="catchItems" :class="$style.services" @change="handleCheckedProduct">
						<el-checkbox v-for="(product, index) in filterItems" :label="product.id" border>
							{{ product.name }}
						</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
			</el-form>
			<div class="btn-group-inline">
				<el-button class="is-round" @click="cancelSelect">取消</el-button>
				<el-button class="is-round" type="primary" @click="saveSelect">儲存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	page: {
	},
	components: {
	},
	filters: {

	},
	computed: {
		filterItems() {
			return this.productItems
		}
	},
	props: {
		type: {
			type: String
		},
		buttonName: {
			type: String
		},
		emptyName: {
			type: String
		}
	},
	data() {
		return {
			productItems: [], //顯示列表
			dialogFilter: '', // 跳窗的dialog filter
			dialogVisible: false, // 開啟跳窗true false
			titleList: [
				{
					'title': '選取適用分店',
					'placeholder': '輸入分店名稱',
					'type': 'product'
				},
				{
					'title': '選取適用服務項目',
					'placeholder': '輸入服務項目名稱',
					'type': 'service'
				}
			],
			dialogTitle: '', // dialog的title
			dialogPlaceHolder: '', // dialog的placeholder
			checkAllBtn: false, // checkbox value
			catchItems: '' // catch到的資料
		}
	},
	mounted() {
		// console.log(this.type)
		this.getProductItem()
	},
	watch: {

	},
	created() {

	},
	methods: {
		setTitlePlaceHolder() {
			const dialogText = this.titleList.find(item => item.type === this.type)
			this.dialogTitle = dialogText.title
			this.dialogPlaceHolder = dialogText.placeholder
		},
		async getProductItem() {
			const { items } = await this.$store.dispatch('product/fetchList', {
				limit: 10000,
				page: 1
			})
			this.productItems = items
		},
		creatAvaliableProdects() {
			this.setTitlePlaceHolder()
			this.dialogVisible = true
		},
		saveSelect() { },
		cancelSelect() {
			this.dialogVisible = false
		},
		checkBoxAllSelectProduct() { },
		handleCheckedProduct() {

		}
	},
}
</script>

<style lang="scss" module>
.box {
	background-color: #f9f9f9;
	border: $color-border-light 1px solid;
	padding: 15px;
	border-radius: 6px;

	:global {
		.inner-box {
			margin-bottom: 20px;
			height: 350px;
			overflow-y: scroll;
		}

		.box {
			&__title {
				white-space: normal;
				text-align: left;
				line-height: 1.4;
				max-width: calc(100% - 100px);
			}
		}

		.el-checkbox-group {
			display: flex;
			flex-wrap: wrap;
		}

		.el-checkbox.is-bordered {
			background-color: #fff;

			.el-checkbox__label {
				white-space: normal;
			}
		}

		.search-in-box {
			.el-input__inner {
				background-color: #fff;
				margin-left: 5px;
				margin-right: 5px;
				margin-bottom: 10px;
			}
		}

		.input-in-buttom {
			display: flex;
			width: 100%;
			justify-content: space-between;
			align-items: center;
		}

		.el-form-item {
			margin-bottom: 15px;
		}

		.el-button {
			.el-input {
				width: 100px;
			}

			.el-input__inner {
				background-color: #fff;
				border-color: $color-border-base;
				height: 30px;

				&:focus {
					// border-color: $color-primary;
				}
			}

			.el-input__suffix {
				top: 7px;
			}
		}

		.inline-section {
			display: flex;
			margin-bottom: 15px;
		}

		.el-button.is-no-border {
			border: 0;
		}
	}
}

.services-wrap {
	border: 1px solid $color-border-for-bg-white;
	border-radius: $border-radius;
}

.dialogTitle {
	background-color: $color-line;
	padding-left: 15px;
}

.services {
	padding: 15px;

	:global {
		label.el-checkbox.is-bordered {
			width: calc(50% - 10px);
			display: inline-flex;
			margin: 5px;
			align-items: center;
			height: auto;
			padding: 15px 20px 15px 15px;

			@include max-sm {
				width: 100%;
			}

			.el-checkbox__inner {
				border-radius: 10px;
				width: 18px;
				height: 18px;

				&:after {
					left: 5px;
					top: 2px;
					height: 8px;
					width: 4px;
					border-width: 2px;
				}
			}

			.el-checkbox__label {
				padding-left: 15px;
				width: 100%;
				overflow-x: auto;
			}

			&+.el-checkbox.is-bordered {
				margin-left: 5px;
			}

			.title,
			.meta {
				width: calc(100% - 20px);
				overflow: hidden;
				text-overflow: ellipsis;
				display: block;
			}

			.content {
				width: 100%;
			}
		}
	}
}
</style>